import React from 'react';

import DebugOutput from '~/src/components/debug/output/DebugOutput';

import css from './DebugTeaser.module.scss';

const DebugTeaser = ({type, format, ...data}) => {
    return (
        <React.Fragment>
            <div className={css.banner}></div>
            <div className={css.content}>
                <h1 className={css.title}>Type: {type}</h1>
                <div className={css.debug}>
                    <DebugOutput message={`Feed:\n${JSON.stringify(data, null, 2)}`} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default DebugTeaser;
